import QuoteReviewWarningsForItems from "./quoteReviewWarningsForItems";
import QuoteReviewWarningsForModules from "./quoteReviewWarningsForModules";

const QuoteReviewWarnings = ({
    warnings,
    quoteItems,
    quoteModules,
    quoteCustomisation,
    onAddWarning,
    onRemoveWarning,
    onAcknowledgedWarningChange,
    onApprovedWarningChange
}) => {

    const moduleWarnings = warnings.filter(x => x.sectionId.startsWith("module|"));
    const quoteModuleGuidsOnQuote = quoteModules.map(x => x.guid);

    // Check if the module that this warning is for is no longer in the quote.  If it's gone we can remove the warning
    const noLongerNeededModuleWarnings = moduleWarnings.filter(warning => 
        warning.sectionId.split("|")[1] && !quoteModuleGuidsOnQuote.includes(warning.sectionId.split("|")[1])
    );

    noLongerNeededModuleWarnings.forEach(warningToRemove => {
        console.log("Removing no longer needed module warning (Module has been removed)", warningToRemove);
        onRemoveWarning(warningToRemove);
    });

    return (
        <div className="mb-5">
            <h4>Warnings</h4>
            <div className="mb-4">
                <i className="bi bi-info-circle m-2 text-warning"></i>Warnings must be acknowledged before the quote can be finalised.
            </div>
            <QuoteReviewWarningsForItems
                warnings={warnings}
                quoteItems={quoteItems}
                onAddWarning={onAddWarning}
                onRemoveWarning={onRemoveWarning}
                onAcknowledgedWarningChange={onAcknowledgedWarningChange}
                onApprovedWarningChange={onApprovedWarningChange}
            />    
            {quoteModules.map(quoteModule => (
                <QuoteReviewWarningsForModules
                    key={quoteModule.guid}
                    warnings={warnings}
                    quoteModuleGuid={quoteModule.guid}
                    quoteModules={quoteModules}
                    onAddWarning={onAddWarning}
                    onRemoveWarning={onRemoveWarning}
                    onAcknowledgedWarningChange={onAcknowledgedWarningChange}
                    onApprovedWarningChange={onApprovedWarningChange}
                />    
            ))}

        </div>
    );
}
export default QuoteReviewWarnings;